import request from '@/utils/request'

const BASE_URL = '';
export default {
  getGuid() {
    return request({
      url: BASE_URL + '/GetGuid'
    })
  },
  getDictionaryList(data = {}) {
    return request({
      url: BASE_URL + '/Dictionary/List',
      method: 'post',
      data
    })
  },
  uploadPhotoUrl: "/Common/UploadPicture",
  deletePhoto(path) {
    return request({
      url: BASE_URL + '/Common/DeletePhoto',
      params: {
        path
      }
    })
  },
  uploadPictureUrl: '/Common/UploadPicture',
  uploadPicture(data) {
    return request({
      url: BASE_URL + '/Common/UploadPicture',
      method: 'post',
      headers: { "Content-Type": "multipart/form-data" },
      data
    })
  }
}